import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

const CUSTOM_YEAR_VALUE = "custom"

// Column filters in the ledger TraceTable (turbo-frame GET forms, turbo index styling).
export default class extends Controller {
  static values = {
    kind: { type: String, default: "date" },
  }

  connect() {
    this.menu = this.element.closest(".dropdown-menu")
    this.boundKeepOpen = (event) => event.stopPropagation()

    if (this.menu) {
      ;["click", "mousedown", "pointerdown"].forEach((type) => {
        this.menu.addEventListener(type, this.boundKeepOpen)
      })
    }

    this.syncCustomDateRange()
  }

  disconnect() {
    if (!this.menu || !this.boundKeepOpen) return

    ;["click", "mousedown", "pointerdown"].forEach((type) => {
      this.menu.removeEventListener(type, this.boundKeepOpen)
    })
  }

  syncCustomDateRange() {
    const datesBlock = this.element.querySelector(".index-header-filter__dates")
    if (!datesBlock) return

    const hasYearPicker = this.element.querySelector(".index-header-filter__years")
    if (!hasYearPicker) {
      datesBlock.classList.remove("d-none")
      return
    }

    const year = this.element.querySelector('[name="year"]:checked')?.value
    datesBlock.classList.toggle("d-none", year !== CUSTOM_YEAR_VALUE)
  }

  prepareSubmit(event) {
    if (this.kindValue !== "date") return

    const form = this.element
    const year = form.querySelector('[name="year"]:checked')?.value
    const fromInput = form.querySelector('[name="period_from"]')
    const toInput = form.querySelector('[name="period_to"]')

    if (!fromInput || !toInput) return

    if (!year || year === "") {
      fromInput.value = ""
      toInput.value = ""
    } else if (year !== CUSTOM_YEAR_VALUE) {
      fromInput.value = `${year}-01-01`
      toInput.value = `${year}-12-31`
    }
  }

  clear(event) {
    event.preventDefault()
    event.stopPropagation()

    const url = event.currentTarget.dataset.ledgerColumnFilterClearUrl
    const frame = this.element.dataset.turboFrame
    if (!url || !frame) return

    Turbo.visit(url, { frame })
  }
}
